import { Injectable } from '@angular/core';
import { _Service } from './_service';
import { DocumentType } from '../../model';
import { buildQuery } from '../../util';
import { HttpOptions } from './http-options.model';

@Injectable({ providedIn: 'root' })
export class DocumentTypeService extends _Service<DocumentType> {
  constructor() {
    super('api/document-type');
  }

  listAll = async (category?: 'company' | 'chain' | 'report' | 'attributes', options?: HttpOptions) =>
    this.http.get<DocumentType[]>(this.prefix + buildQuery({ category }), options);
}
